import { render, staticRenderFns } from "./PostulacionCambio.vue?vue&type=template&id=07d4a8e8"
import script from "./PostulacionCambio.vue?vue&type=script&lang=js"
export * from "./PostulacionCambio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports